import type { StatusColor } from '@ztechapps/common.contract'
import { resolveStatusColor } from './resolveStatusColor'

/** A status map entry's fill/text as a FullCalendar event's background, border and text colour. */
export type CalendarEventColor = { backgroundColor?: string; borderColor?: string; textColor?: string }

export const resolveCalendarEventColor = (statusColor?: StatusColor): CalendarEventColor => {
  const resolved = resolveStatusColor(statusColor)
  return { backgroundColor: resolved?.fill, borderColor: resolved?.fill, textColor: resolved?.text }
}
